import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faUserTimes } from '@fortawesome/pro-solid-svg-icons';
import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { SortUtils } from '../../../../../utils/sorting';
import { useGetClassManagementStudentsMutation, useGetClassEditStatusMutation } from '../../../../../features/authentication/classesApiSlice';
import FloatingBar from '../components/floatingBar';
import SendMessage from '../../../../dashboard/components/Modals/SendMessage';
import { useDashboardContext } from '../../../../dashboard/context';
import SelectRecipientModal from '../../../../dashboard/components/Modals/SelectRecipientModal';
import CreateDistributionList from '../../../../dashboard/components/Modals/CreateDistributionList';
import GroupDetailsUpdations from '../../../../dashboard/components/Modals/GroupDetailsUpations';
import ManageDistList from '../../../../dashboard/components/Modals/ManageDistList';
import StudentList from '../components/studentList';
import { useClassManagementActions } from '../utils/classManagementActions';
import { useClassManagementContext } from '../utils/classManagementContext';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import DropDown from '../../../../../components/DropDown';
import Modal from '../../../../../components/Modal';
import ToggleCheckbox from '../../../../../components/CheckboxToggle';
import {
  useGetClassesMutation
} from '../../../../../features/authentication/authApiSlice';
import ViewCoTeachersModal from '../../../../assignments/pages/AssignmentsAndActivities/Components/modals/ViewCoTeachersModal';
import { useClassContext } from '../../../components/classContext';
import CalendarLink from '../components/calendarLink';
import { useNavigate } from 'react-router-dom';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import { useSelector } from 'react-redux';
import { selectFerpaState, selectCurrentUserData } from '../../../../../features/authentication/authSlice';
import Cookies from 'js-cookie';
import { faCircleQuestion, faFileExport, faPrint, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { convertToCSV, downloadCSV } from '../../../../assignments/utils';
import PageSize from '../../../../../enums/pageSize';
import usePrintPdfGenerator from '../../../../../utils/PrintPdfGenerator';

const ClassManagementList = () => {
  const { setClassId } = useClassContext();
  const { classes, setClasses, selectedClassId, coTeachers, setCoTeachers } = useClassManagementContext();
  const initialShowHiddenStudent = Cookies.get('displayRemovedStudents') === 'true';
  const user = useSelector(selectCurrentUserData);

  const [getAllStudents] = useGetClassManagementStudentsMutation();
  const [getClassEditStatus] = useGetClassEditStatusMutation();

  const [sortColumn, setSortColumn] = useState('lName');
  const [sortDirection, setSortDirection] = useState('asc');
  const [students, setStudents] = useState(null);
  const [allowedToEdit, setAllowedToEdit] = useState(false);
  const [preventChangePassword, setPreventChangePassword] = useState(false);
  const [displayUserPasswords, setDisplayUserPasswords] = useState(false);
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [triggerConfirmAction, setTriggerConfirmAction] = useState(false);
  const [openMoveModel, setOpenMoveModel] = useState(false);
  const [openTransferModel, setOpenTransferModel] = useState(false);
  const [moveSelectedClass, setMoveSelectedClass] = useState(null);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [confirmationTitle, setConfirmationTitle] = useState('');
  const [dateBasedKey, setDateBasedKey] = useState(new Date().getTime().toString());
  const [transferOwnershipOfAssignment, setTransferOwnershipOfAssignment] = useState(false);
  const [stayAsCoTeacher, setStayAsCoTeacher] = useState(true);
  const [transferTeacherId, setTransferTeacherId] = useState(null);
  const [openCoTeachersModal, setOpenCoTeachersModal] = useState(false);
  const [isCoTeacherClass, setIsCoTeacherClass] = useState(false);
  const [openCalendarLinkModal, setOpenCalendarLinkModal] = useState(false);
  const [showRemoved, setShowRemoved] = useState(initialShowHiddenStudent);
  const [checkAllStatus, setCheckAllStatus] = useState(false);
  const [openNoStudentModal, setOpenNoStudentModal] = useState(false);
  const [openShowPasswordModal, setOpenShowPasswordModal] = useState(false);
  const [openClearPasswordConfirmation, setOpenClearPasswordConfirmation] = useState(false);
  const [isCsvGenerating, setIsCsvGenerating] = useState(false);
  const [transferableTeacher, setTransferableTeacher] = useState(null);
  const [isDistrictManaged, setIsDistrictManaged] = useState(false);
  const { printPDF, isPdfGenerating } = usePrintPdfGenerator();

  const ferpaEnabled = useSelector(selectFerpaState);
  const [getAllClasses] = useGetClassesMutation();
  const { allStudents } = useDashboardContext();
  const navigate = useNavigate();

  const {
    sendMessageAction,
    clearPasswordAction,
    moveAction,
    hideAction,
    unhideAction,
    transferOwnershipAction
  } = useClassManagementActions();

  useEffect(() => {
    Cookies.set('displayRemovedStudents', showRemoved, { expires: 7 });
    if(checkAllStatus && !showRemoved)
    {     
      handleCheckAllChange(checkAllStatus);
    }else{
      updateCheckAllStatus();
    }
    if(allowedToEdit && students?.filter(x=> showRemoved || (!x.deleted && !x.deactivated)).length == 0)
    {
      setOpenNoStudentModal(true);
    }
  }, [showRemoved]);

  useEffect(() => {
    if (selectedClassId) {
      loadStudents();
      getAllowedToEditStatus();
      setClassId(selectedClassId);
      setCheckAllStatus(false);
    }
  }, [selectedClassId]);

  useEffect(() => {
    if (triggerConfirmAction)
      confirmAction();
  }, [triggerConfirmAction]);

  useEffect(() => {
    setDateBasedKey(new Date().getTime().toString());
    if(allowedToEdit && students?.filter(x=> showRemoved || (!x.deleted && !x.deactivated)).length == 0)
    {
      setOpenNoStudentModal(true);
    }
  }, [students]);

  useEffect(()=>{
    if(coTeachers && coTeachers.length>0)
      setTransferableTeacher([
        ...coTeachers.map((item) => ({
          name: item.name,
          id: item.teacherId,
        }))
      ]);
    else
      setTransferableTeacher(null);
  }, [coTeachers]);

  const renderSortIcons = (column) => {
    return (SortUtils.renderSortIcons(sortDirection, sortColumn, column));
  };

  const handleSort = async (column) => {
    if(!ferpaEnabled)
      return;
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    let sortedStudent = await SortUtils.customSort(students, column, direction === 'asc');
    setStudents(sortedStudent);
  };

  const loadStudents = async () => {
    setStudents(null);
    const options = {
      id: selectedClassId,
      includeDeleted: true
    };
    const studentList = await getAllStudents(options).unwrap();
    setStudents(studentList);
  };

  const getAllowedToEditStatus = async (isFromTransfer) => {  
    var result = await getClassEditStatus(selectedClassId).unwrap();
    setAllowedToEdit(result.allowedToEdit);
    setPreventChangePassword(result.preventChangePassword);
    setDisplayUserPasswords(result.displayUserPasswords);
    setIsDistrictManaged(result.isDistrictManaged);
    if(isFromTransfer)
      setIsCoTeacherClass(true);
    else{
      const selectedItem = classes.find(item => item.id == selectedClassId);
      setIsCoTeacherClass(selectedItem?.coTeacherClass);
    }
  };

  const handleCheckAllChange = (checked) => {
    let modifiedStudents = [];
    modifiedStudents = students.map((item) => {
      return (item.deleted? item : ((showRemoved || !item.deactivated) ? { ...item, isChecked: checked }: { ...item, isChecked: false }));
    });
    setStudents(modifiedStudents);
    updateCheckAllStatus(modifiedStudents);
  };

  const handleCheckBoxChange = (e) => {
    const {name, checked } = e.target;
    let modifiedStudents = [];
    const id = parseInt(name);
    modifiedStudents = students.map((item) =>
      item.studentId === id && !item.deleted ? { ...item, isChecked: checked } : item
    );
    setStudents(modifiedStudents);
    updateCheckAllStatus(modifiedStudents);
  };

  const updateCheckAllStatus=(modifiedStudents)=>
  {
    setCheckAllStatus(getCheckAllStatus(modifiedStudents));
  };

  const getCheckAllStatus = (modifiedStudents)=>
  {
    return (modifiedStudents?.filter((item) => (showRemoved || !item.deactivated) && !item.deleted && !item.isChecked).length < 1);
  };

  const handleAction = (actionType, students) => {
    if (!Array.isArray(students)) {
      students = [students];
    }

    setSelectedAction(actionType);
    setSelectedStudents(students);

    if (actionType == 'ClearPassword') {
      setConfirmationMessage(clearConfirmationMessage(students));
      setConfirmationTitle('Clear Password');
      setIsConfirmationVisible(true);
    }
    else if (actionType == 'Move') {
      setMoveSelectedClass(classes.filter(x => x.id != selectedClassId)[0].id);
      setOpenMoveModel(true);
    }
    else if (actionType == 'Hide') {
      setConfirmationMessage(hideConfirmationMessage(students));
      setConfirmationTitle(students.length>1?'Hide Students':'Hide Student');
      setIsConfirmationVisible(true);
    }
    else if (actionType == 'Unhide') {
      setConfirmationMessage(unhideConfirmationMessage(students));
      setConfirmationTitle(students.length>1?'Unhide Students':'Unhide Student');
      setIsConfirmationVisible(true);
    }
    else if (actionType == 'TransferOwnership') {
      setTransferTeacherId(transferableTeacher[0]?.id);
      setOpenTransferModel(true);
    }
    else
      setTriggerConfirmAction(true);
  };

  const confirmAction = async () => {
    setIsConfirmationVisible(false);
    setTriggerConfirmAction(false);

    switch (selectedAction) {
    case 'SendMessage':
      sendMessageAction(selectedStudents);
      break;
    case 'PrintIDCards':
      navigate('idCards',{state: { students: selectedStudents }});
      break;
    case 'ClearPassword':
      setOpenClearPasswordConfirmation(true);
      break;
    case 'Move':
      setOpenMoveModel(false);
      await moveAction(selectedStudents, parseInt(selectedClassId), parseInt(moveSelectedClass), loadStudents);
      break;
    case 'Hide':
      hideAction(selectedStudents, parseInt(selectedClassId), loadStudents);
      break;
    case 'Unhide':
      unhideAction(selectedStudents, parseInt(selectedClassId), loadStudents, true);
      break;
    case 'TransferOwnership':
      var response = await transferOwnershipAction(parseInt(selectedClassId), transferTeacherId, transferOwnershipOfAssignment, stayAsCoTeacher);
      if (response) {
        setOpenTransferModel(false);
        reloadClasses();
        getAllowedToEditStatus(true);
      }
      break;
    case 'ManageCoTeacher':
      setOpenCoTeachersModal(true);
      break;
    case 'SaveGoogleCalendarLink':
      setOpenCalendarLinkModal(true);
      break;
    case 'AddStudents':
      navigate('addStudents',{state: { selectedClass: classes.filter(x=> x.id == selectedClassId)[0]}});
      break;
    case 'ViewPassword':
      setOpenShowPasswordModal(true);
      break;
    default:
      console.error(`Unknown action: ${selectedAction}`);
    }
  };

  const reloadClasses = async () => {
    localStorage.removeItem('classes');
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    setClasses([
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        coteacherName: item.coTeacherClass ? item.teacherName : '',
        coTeacherClass: item.coTeacherClass
      }))
    ]);
  };

  const clearConfirmationMessage = (studentsSelected) => {
    return (studentsSelected.length > 1 ? `<span><b>Are you sure that you want to clear the password for the selected students?</b>
    </br> If students forget their password, clearing it allows them to log in and choose another password.
     Note that this will leave the accounts in an unsecure state. It is preferable that you have the students use the Forgot Password link with either their primary or secondary email when logging in.
     </br> Click Yes to clear the passwords, then advise the students to log in as soon as possible in order to establish a new password.</span>` :
      `If students forget their password, clearing it allows them to log in and choose another password.
      </br>
      If clearing this password, then advise the student to log in as soon as possible in order to establish a new password. Note that this will leave the account in an unsecure state.
       It is preferable that you have the student use the Forgot Password link with either their primary or secondary email when logging in.
      
      </br><b>Are you sure that you want to clear the password for ${studentsSelected[0]?.lName}  ${studentsSelected[0]?.fName} ?</b>`
    );
  };

  const hideConfirmationMessage = (studentsSelected) => {
    return (studentsSelected.length > 1 ? 'Are you sure that you want to hide the checked students from this class?'
      : `Are you sure that you want to hide ${studentsSelected[0].lName + ' ' + studentsSelected[0].fName}  from this class?`);
  };

  const unhideConfirmationMessage = (studentsSelected) => {
    return (studentsSelected.length > 1 ? 'Are you sure that you want to unhide the checked students from this class?'
      : `Are you sure that you want to unhide ${studentsSelected[0].lName + ' ' + studentsSelected[0].fName}  from this class?`);
  };

  const handleMoveClassChange = (e) => {
    setMoveSelectedClass(parseInt(e.target.value));
  };

  const handleTransferTeacherChange = (e) => {
    setTransferTeacherId(parseInt(e.target.value));
  };

  const handleDisplayRemoved = () =>
  {
    setShowRemoved(!showRemoved);
  };

  const clearPasswordDoubleConfirm =() =>
  {
    setOpenClearPasswordConfirmation(false);
    clearPasswordAction(selectedStudents, parseInt(selectedClassId), loadStudents);
  };

  const handleExportToPdf = async () => {
    if(isPdfGenerating) return;

    var className = classes.find(x=>x.id == selectedClassId)?.name;
    const contentWrapper = document.getElementById('printWrapper');
    const htmlString = contentWrapper.innerHTML;
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const table = tempContainer.querySelector('table');

    if (table) {
      const columnsToHide = table.querySelectorAll('.column-to-hide');
      columnsToHide.forEach(col => {
        col.style.display = 'none';
      });

      const columnsToShow = table.querySelectorAll('.column-to-show');
      columnsToShow.forEach(col => {
        col.style.display = 'table-cell';
        col.classList.remove('d-none');
      });
    }
    const title = tempContainer.querySelectorAll('.hidden-row');
    title.forEach(item => {
      if (item.classList.contains('d-none')) {
        item.classList.remove('d-none');
      }
    });

    const sortingArrows = tempContainer.querySelectorAll('span.sortingArrows');
    sortingArrows.forEach(span => {
      span.classList.add('d-none');
    });

    const hideForPrint = tempContainer.querySelectorAll('.hideForPrint');
    hideForPrint.forEach(item => {
      item.classList.add('d-none');
    });
    
    await printPDF(className, tempContainer.innerHTML, PageSize.A4, true);
  };

  const handleExportToCsv = async () => {
    setIsCsvGenerating(true);
    var className = classes.find(x=>x.id == selectedClassId)?.name;
    const exportingDetails = students.filter(x=> (showRemoved || (!x.deleted && !x.deactivated))).map((student)=>({
      FIRST: ferpaEnabled ? student.lName : 'Hidden',
      LAST: ferpaEnabled ? student.fName : 'Hidden',
      STUDENTID: ferpaEnabled ? student.identification : 'Id Hidden',
      LOGIN: ferpaEnabled ? student.login : 'Login Hidden',
      Grade: student.code
    }));
   
    const newData = {
      StudentsInfo : exportingDetails,
    };

    const csvData = convertToCSV(newData);
    let modifiedCsv = csvData.replace('StudentsInfo', 'CLASS DETAILS : '+className);
    downloadCSV(modifiedCsv, className);
    setIsCsvGenerating(false);
  };

  return (
    <>
      <Row className='mb-4'>
        <Col className='align-items-center clr-castleRed col d-flex justify-content-end export-btn' >
          <button className='btn btn-link primary-link' disabled={isCsvGenerating} onClick={()=> handleExportToCsv()}>
            <FontAwesomeIcon icon={faFileExport} />&nbsp;
            {isCsvGenerating ? <>Exporting&nbsp;<FontAwesomeIcon icon={faSpinner} spin /></> :'Export Class'}
          </button>
          <button className='btn btn-link primary-link' disabled={isPdfGenerating} onClick={()=> handleExportToPdf()}>
            <FontAwesomeIcon icon={faPrint} />&nbsp;
            {isPdfGenerating? <>Generating&nbsp;<FontAwesomeIcon icon={faSpinner} spin /></> : 'Print to PDF'}
          </button>
        </Col>
      </Row>
      <div id='printWrapper'>
        <Row className='d-none hidden-row'>
          <Col className='mb-1'>
            <div> <span className='fw-medium mr-2'>Teacher:&nbsp;</span>{user?.Salutation}&nbsp;{user?.LastName}</div>
            <div><span className='fw-medium mr-2'>Class:&nbsp;</span>{classes.find(x=>x.id == selectedClassId)?.name}</div>
            <div><span className='fw-medium'>Report Date:&nbsp;</span>{new Date().toLocaleTimeString()}</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className='d-flex justify-content-between mb-4'>
              <div className='fw-medium'>
                  Number Of students <span className="rounded-number mx-1 fw-semibold">{students?(showRemoved?students.length:students.filter(x=>!x.deleted && !x.deactivated).length):0}</span>
              </div>
              <div className='hideForPrint'>
                <input
                  type="checkbox"
                  className="form-check-input me-2 cursor-pointer"
                  checked={showRemoved}
                  id="flexCheckDefault"
                  name="allselect"
                  onChange={() => handleDisplayRemoved()}
                />
                <label className="form-check-label">
                Display Hidden/Removed Students&nbsp; 
                  <OverlayTrigger
                    key={'assignment-options'}
                    placement="top"
                    overlay={
                      <Tooltip className="initial-assignment-tooltip">
                        <div>
                        Removed students include those that are Hidden (by teacher), Disabled (by district), or Deactivated (based on account activity or manual deactivation)
                        </div>
                      </Tooltip>
                    }>
                    <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                  </OverlayTrigger>
                </label>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className='table-container'>
            <table className='table reportTable'>
              {students ? (
                <>
                  <thead className='thead-light align-middle table-head thead-fixed'>
                    <tr>
                      <th className='column-to-hide'>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            value=""
                            id="assignCheck"
                            name="assignCheck"
                            checked={checkAllStatus}
                            onChange={(e)=> handleCheckAllChange(e.target.checked)}
                          />
                        </div>
                      </th>
                      <th scope="col" className={`fw-medium ${ferpaEnabled?'cursor-pointer':''}`} onClick={() => handleSort('lName')}>
                        <span className='align-items-center d-flex justify-content-between'> <span>Last Name</span> {ferpaEnabled && renderSortIcons('lName')} </span>
                      </th>
                      <th scope="col" className={`fw-medium ${ferpaEnabled?'cursor-pointer':''}`} onClick={() => handleSort('fName')}>
                        <span className='align-items-center d-flex justify-content-between'><span>First Name</span> {ferpaEnabled && renderSortIcons('fName')}</span>
                      </th>
                      <th scope="col" className={`fw-medium ${ferpaEnabled?'cursor-pointer':''}`} onClick={() => handleSort('identification')}>
                        <span className='align-items-center d-flex justify-content-between'><span>Identification</span> {ferpaEnabled && renderSortIcons('identification')}</span>
                      </th>
                      <th scope="col" className={`fw-medium ${ferpaEnabled?'cursor-pointer':''}`} onClick={() => handleSort('login')}>
                        <span className='align-items-center d-flex justify-content-between'><span>Login Id</span> {ferpaEnabled && renderSortIcons('login')}</span>
                      </th>
                      <th scope="col" className='fw-medium d-none column-to-show'>
                        <span className='align-items-center'><span>Grade</span></span>
                      </th>
                      <th scope="col" className={`fw-medium ${ferpaEnabled?'cursor-pointer':''} min-w-150 column-to-hide`}>
                        <span className='align-items-center d-flex justify-content-between'><span>Password Actions</span></span>
                      </th>
                      <th scope="col" className='fw-medium min-w-150 column-to-hide'>
                        <span className='align-items-center d-flex justify-content-between'>     </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {students?.filter(x=> (showRemoved || (!x.deleted && !x.deactivated))).map((item) => (
                      <tr key={`record_${item.studentId}`}>
                        <td className='column-to-hide'>
                          <div className='d-flex align-items-center'>
                            {!item.deleted && (
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  value=""
                                  name={item.studentId}
                                  checked={item?.isChecked}
                                  onChange={handleCheckBoxChange}
                                  className="form-check-input"
                                  id={`flexCheckDefault-${item.studentId}`}
                                />
                              </div>
                            )}
                            {item.deleted &&
                        <OverlayTrigger
                          key={`deleted_${item.studentId}`}
                          placement="top"
                          overlay={<Tooltip className="custom-tooltip">Click to Unhide
                          </Tooltip>}>
                          <div className='hiddenStudent' onClick={()=> handleAction('Unhide', item)}>
                            <FontAwesomeIcon icon={faEyeSlash} className='p-1' />
                          </div>
                        </OverlayTrigger>
                            }
                            {item.deactivated &&
                        <OverlayTrigger
                          key={`deactivated_${item.studentId}`}
                          placement="top"
                          overlay={<Tooltip className="custom-tooltip">Deactivated
                          </Tooltip>}>
                          <div className='deactiveStudent'>
                            <FontAwesomeIcon icon={faUserTimes} className='p-1' />
                          </div>
                        </OverlayTrigger>}
                          </div>
                        </td>

                        <StudentList student={item} onAction={handleAction} allowedToEdit={allowedToEdit} displayUserPasswords={displayUserPasswords} preventChangePassword={preventChangePassword} ferpaEnabled={ferpaEnabled} isDistrictManaged={isDistrictManaged} />
                      </tr>
                    ))}
                    {students?.filter(x=> showRemoved || (!x.deleted && !x.deactivated)).length == 0 && <tr>
                      <td colSpan='5' className='p-3 text-danger'>There are no students in the class.</td>
                    </tr>}
                  </tbody>
                </>
              ) : (
                <TableSkeleton
                  colCount={7}
                  rowCount={4}/>
              )}
            </table>
          </Col>
        </Row>
      </div>
      <FloatingBar
        key={'floatingBar' + dateBasedKey} 
        selectedStudents={students?.filter(x => x.isChecked)} 
        onAction={handleAction}
        allowedToEdit={allowedToEdit}
        preventChangePassword={preventChangePassword}
        anyCoTeacher={transferableTeacher?.length > 0} 
        isCoTeacherClass={isCoTeacherClass}
        isDistrictManaged={isDistrictManaged}
      />
      
      <SendMessage fromClassList={true} />
      <SelectRecipientModal
        title={'Select recipients'}
        saveButton={'Save'}
        addRemoveListHeader={'Send Message To'}
        addByLabel={'Add by Distribution Lists'}
        manageButton={'Select/Manage Distribution Lists'}
        dataArray={allStudents}
      />
      <CreateDistributionList />
      <GroupDetailsUpdations />
      <ManageDistList
        title={'Manage Distribution List'}
        label={'Enter the name for the distribution list'}
        createButton={'Create List'}
        firstColumnTitle={'List Name'}
      />

      <ConfirmationModal
        key={'confirmation' + dateBasedKey}
        isOpen={isConfirmationVisible}
        onClose={() => setIsConfirmationVisible(false)}
        onSave={() => confirmAction()}
        contentWidth={'655px'}
        buttonPosition={'center'}
        content={confirmationMessage}
        titleName={confirmationTitle}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />

      <Modal
        key={'move' + dateBasedKey}
        isOpen={openMoveModel}
        onClose={() => setOpenMoveModel(false)}
        contentWidth="40%"
        titleName={selectedStudents.length>1 ? 'Move Students' : 'Move Student'}
      >
        <Container>
          <Row>
            <Col>
              <DropDown
                key='classSelect'
                label="Class"
                value={classes.filter(x => x.id != selectedClassId)}
                onChangeHandler={(e) => handleMoveClassChange(e)}
                selectedValue={moveSelectedClass}
                dropDownName={'MoveClass'}
              />
            </Col>
          </Row>
          <Row className='justify-content-end mt-4'>
            <Col className='col-5'>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-castleGray flex-grow-1 mr-2'
                  onClick={() => setOpenMoveModel(false)}>
                    Cancel
                </button>
                <button
                  className='btn btn-castleRed flex-grow-1'
                  onClick={() => confirmAction()}>
                    Move&nbsp;
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>

      <Modal
        key={'transfer' + dateBasedKey}
        isOpen={openTransferModel}
        onClose={() => setOpenTransferModel(false)}
        contentWidth="45%"
        titleName={'Transfer Class'}
      >
        <Container>
          <Row>
            <Col>
              <span>Select the teacher you want to transfer this class to.
                  Note that once the class is transferred you lose ownership and become a co-teacher.</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <DropDown
                key='TransferTeachers'
                label=""
                value={transferableTeacher}
                onChangeHandler={(e) => handleTransferTeacherChange(e)}
                selectedValue={transferTeacherId}
                dropDownName={'transfer'}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <div className='mt-3 mb-3'>
                  Would you like to transfer ownership of your assignments that are co-taught by this teacher to this teacher?
              </div>
              <div>
                <ToggleCheckbox
                  id={'transferToggle'}
                  checked={transferOwnershipOfAssignment}
                  onChange={() => setTransferOwnershipOfAssignment(!transferOwnershipOfAssignment)}
                />
              </div>
            </Col>
          </Row>
          {transferOwnershipOfAssignment && <Row>
            <Col>
              <div className='mt-3 mb-3'>
                  Would you like to still have access to these assignments? (by being a co-teacher)
              </div>
              <div>
                <ToggleCheckbox
                  id={'stayAsCoTeacher'}
                  checked={stayAsCoTeacher}
                  onChange={() => setStayAsCoTeacher(!stayAsCoTeacher)}
                />
              </div>
            </Col>
          </Row>
          }
          <Row className='justify-content-end mt-4'>
            <Col className='col-5'>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-castleGray flex-grow-1 mr-2'
                  onClick={() => setOpenTransferModel(false)}>
                    Cancel
                </button>
                <button
                  className='btn btn-castleRed flex-grow-1'
                  onClick={() => confirmAction()}>
                    Transfer
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>

      {openCoTeachersModal && (
        <ViewCoTeachersModal
          key={'coTeacher' + dateBasedKey}
          modalData={openCoTeachersModal}
          onClose={() => setOpenCoTeachersModal(false)}
          coteachers={coTeachers}
          setCoteachers={setCoTeachers}
          coTeachersDataLoading={false}
        />
      )}

      {openCalendarLinkModal && (
        <CalendarLink
          key={'calendarModel'}
          isOpen={openCalendarLinkModal}
          onClose={()=>setOpenCalendarLinkModal(false)}
          classId={selectedClassId}
        />
      )}

      <Modal
        key={'addStudent' + dateBasedKey}
        isOpen={openNoStudentModal}
        onClose={() => setOpenNoStudentModal(false)}
        contentWidth="45%"
        titleName={'You Want To Add Students Now?'}
      >
        <Container>
          <Row>
            <Col>
              <span>You do not have any students in the selected class. Would you like to add students to the class now?
              </span>
            </Col>
          </Row>
          <Row className='justify-content-end mt-4'>
            <Col className='col-5'>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-castleGray flex-grow-1 mr-2'
                  onClick={() => setOpenNoStudentModal(false)}>
                    No
                </button>
                <button
                  className='btn btn-castleRed flex-grow-1'
                  onClick={() => handleAction('AddStudents')}>
                    Yes
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>

      <Modal
        key={'showPassword' + dateBasedKey}
        isOpen={openShowPasswordModal}
        onClose={() => setOpenShowPasswordModal(false)}
        contentWidth="40%"
        titleName={'Password Details'}
      >
        <Container>
          <Row>
            <Col className='col my-2'>
              The password for student <i className='fw-medium'>{selectedStudents[0]?.lName}&nbsp;{selectedStudents[0]?.fName}</i> is <b className='link-orange'>{selectedStudents[0]?.password}</b>
            </Col>
          </Row>
        </Container>
      </Modal>

      <Modal
        key={'clearPassword' + dateBasedKey}
        isOpen={openClearPasswordConfirmation}
        onClose={() => setOpenClearPasswordConfirmation(false)}
        contentWidth="25%"
        titleName={'Confirm?'}
      >
        <Container>
          <Row>
            <Col>
              Are you really sure?             
            </Col>
          </Row>
          <Row className='justify-content-end mt-4'>
            <Col className='col-8'>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-castleGray flex-grow-1 mr-2'
                  onClick={() => setOpenClearPasswordConfirmation(false)}>
                    No
                </button>
                <button
                  className='btn btn-castleRed flex-grow-1'
                  onClick={() => clearPasswordDoubleConfirm()}>
                    Yes
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
      
    </>
  );
};

export default ClassManagementList;